/**
 * Http service to retrieve permissions
 */
angular
  .module('http.permissions', [])
  /**
   * Service used to access calls to the permissions rest services.
   */
  .factory('httpPermissions', function ($http) {
    class HttpPermissions {
      /**
       * Send a request to retrieve the permissions of current user
       * @returns {Promise<*>} permissions
       */
      static getPermissions() {
        return $http({
          method: 'GET',
          url: 'api/permissions'
        }).then(function (res) {
          return res.data;
        });
      }

      static getUserPermissions(userId) {
        return $http({
          method: 'GET',
          url: `api/permissions/${userId}`
        }).then(function (res) {
          return res.data;
        });
      }

      static assignPermissions(userId, superAdmin, permissions) {
        return $http({
          method: 'PUT',
          url: `api/permissions`,
          data: {
            userId,
            superAdmin,
            permissions
          }
        }).then(function (res) {
          return res.data;
        });
      }
    }

    return HttpPermissions;
  });
